export var classListSupport = 'classList' in document.createElement('_');